import { Button, Input } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { AppContext } from "../../../context/AppContext";

export default function AutomaticConfig(props) {
  const { courses, subjects, tags, topics, users } = useContext(AppContext);

  const [approvedBy, setApprovedBy] = useState("");
  const [courseIds, setCourseIds] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);

  const filteredTopics = topics.filter((topic) => {
    if (typeof subjectIds === "object" && subjectIds !== null) {
      // if subjectIds is an object, filter based on value property of object values
      return subjectIds.value === topic.subjectId;
    } else {
      // if subjectIds is not an array or an object, return all topics
      return true;
    }
  });

  const [tagIds, setTagIds] = useState([]);
  const [topicIds, setTopicIds] = useState([]);
  const [createdBy, setCreatedBy] = useState("");
  const [questionComplexity, setQuestionComplexity] = useState({
    value: "ALL",
    label: "ALL",
  });
  const [numOfTimesUsedInExam, setNumOfTimesUsedInExam] = useState(0);
  const [createdDate, setCreatedDate] = useState(null);
  const [updatedDate, setUpdatedDate] = useState(null);
  const [totalQuestion, setTotalQuestion] = useState(0);
  const [issueReported, setIssueReported] = useState({
    value: false,
    label: "False",
  });
  const [includeQuestionsFromQB, setIncludeQuestionsFromQB] = useState({
    value: true,
    label: "True",
  });

  const onReset = () => {
    setApprovedBy("");
    setCourseIds([]);
    setSubjectIds([]);
    setTagIds([]);
    setTopicIds([]);
    setCreatedBy("");
    setQuestionComplexity({
      value: "ALL",
      label: "ALL",
    });
    setNumOfTimesUsedInExam(0);
    setCreatedDate(null);
    setUpdatedDate(null);
    setIssueReported({
      value: false,
      label: "False",
    });
    setIncludeQuestionsFromQB({
      value: true,
      label: "True",
    });
  }

  const onResetConfig = () => {
    props.resetConfig([])
  }

  useEffect(() => {
      console.log('subjectIds: ', subjectIds);
      console.log('props.automaticConfig: ', props.automaticConfig);
      console.log('props.showAutomaticFilter: ', props.showAutomaticFilter);
    if (props.showAutomaticFilter && subjectIds) {
      const automaticSubjectIndex = props.automaticConfig.findIndex(config => config.subjectIds.value === subjectIds.value);
      if (automaticSubjectIndex > -1) {
        setCourseIds(props.automaticConfig[automaticSubjectIndex].courseIds || []);
        setTagIds(props.automaticConfig[automaticSubjectIndex].tagIds || []);
        setTopicIds(props.automaticConfig[automaticSubjectIndex].topicIds || []);
        setQuestionComplexity(props.automaticConfig[automaticSubjectIndex].questionComplexity || '');
        setNumOfTimesUsedInExam(props.automaticConfig[automaticSubjectIndex].numOfTimesUsedInExam || '');
        setIssueReported(props.automaticConfig[automaticSubjectIndex].issueReported || '');
        setIncludeQuestionsFromQB(props.automaticConfig[automaticSubjectIndex].includeQuestionsFromQB || '');
        setTotalQuestion(props.automaticConfig[automaticSubjectIndex].totalQuestion || '');
        setCreatedBy(props.automaticConfig[automaticSubjectIndex].createdBy || '');
        setApprovedBy(props.automaticConfig[automaticSubjectIndex].approvedBy || '');

      } else {
        setCourseIds([]);
        setTagIds([]);
        setTopicIds([]);
        setQuestionComplexity('');
        setNumOfTimesUsedInExam('');
        setIssueReported('');
        setIncludeQuestionsFromQB('');
        setTotalQuestion(0);
        setCreatedBy('');
        setApprovedBy('');
      }
    }
  }, [props.showAutomaticFilter, props.automaticConfig, subjectIds.value]);
  

  return (
    <div>
     <div
        style={{
          display: "flex",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        {props.subjectValue.map((el) => (
            <div style={{ margin: "10px" }}>
              <div>{el.label}</div>
              <div className={`form-details ${(props.automaticConfig.filter(ac => +(el.value) === +(ac['subjectIds']['value']))).reduce((acc,vl) => {
                acc += +(vl.totalQuestion)
                return acc
             },0) === 0 && "error-automate-input"}`} style={{ marginTop: "5px" }}>
                
             { (props.automaticConfig.filter(ac => +(el.value) === +(ac['subjectIds']['value']))).reduce((acc,vl) => {
                acc += +(vl.totalQuestion)
                return acc
             },0)
             }
              </div>
            </div>
          ))}
      </div>
      {props?.showAutomaticFilter && (
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Subject</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  value={subjectIds}
                  options={props.subjectValue.map((el) => {
                    return {
                      value: el.value,
                      label: el.label,
                    };
                  })}
                  onChange={(item) => {
                    setSubjectIds(item);
                    if (item.length === 0) {
                      props.search({
                        approvedBy,
                        courseIds,
                        subjectIds,
                        tagIds,
                        topicIds,
                        createdBy,
                        questionComplexity,
                        numOfTimesUsedInExam,
                        issueReported,
                        includeQuestionsFromQB,
                        createdDate,
                        updatedDate,
                      });
                    }
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Question Count</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
              <input
              class="form-details"
              value={totalQuestion}
              onChange={(e) => {
                setTotalQuestion(e.target.value);
              }}
              type="number"
              name="totalQuestionsobj"
            />
              </div>
            </div>
            
            <div class="form-sub-div">
              <label class="form-label">Course</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={courseIds}
                  options={courses.map((el) => {
                    return {
                      value: el.courseId,
                      label: el.course,
                    };
                  })}
                  onChange={(item) => {
                    setCourseIds(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Tags</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={tagIds}
                  options={tags.map((el) => {
                    return {
                      value: el.tagId,
                      label: el.tagName,
                    };
                  })}
                  onChange={(item) => {
                    setTagIds(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Topics</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti
                  value={topicIds}
                  options={filteredTopics.map((el) => {
                    return {
                      value: el.topicId,
                      label: el.topic,
                    };
                  })}
                  onChange={(item) => {
                    setTopicIds(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Created by</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={createdBy}
                  options={users.map((el) => {
                    return {
                      value: el.userID,
                      label: el.email,
                    };
                  })}
                  onChange={(item) => {
                    setCreatedBy(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Approved by</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  value={approvedBy}
                  options={users.map((el) => {
                    return {
                      value: el.userID,
                      label: el.email,
                    };
                  })}
                  onChange={(item) => {
                    setApprovedBy(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Issue Reported</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={issueReported}
                  options={[
                    { value: true, label: "True" },
                    { value: false, label: "False" },
                  ]}
                  onChange={(item) => {
                    setIssueReported(item);
                  }}
                ></Select>
              </div>
            </div>
            <div class="form-sub-div">
              <label class="form-label">Include Questions From QB</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  value={includeQuestionsFromQB}
                  options={[
                    { value: true, label: "True" },
                    { value: false, label: "False" },
                  ]}
                  onChange={(item) => {
                    setIncludeQuestionsFromQB(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">Complexity</label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Select
                  isMulti={false}
                  value={questionComplexity}
                  options={[
                    { value: "ALL", label: "ALL" },
                    { value: "EASY", label: "EASY" },
                    { value: "MEDIUM", label: "MEDIUM" },
                    { value: "HIGH", label: "HIGH" },
                  ]}
                  onChange={(item) => {
                    setQuestionComplexity(item);
                  }}
                ></Select>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">{`Created Date >`} </label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Input
                  type="date"
                  value={createdDate}
                  onChange={(item) => {
                    setCreatedDate(item.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">{`Updated Date >`} </label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Input
                  type="date"
                  value={updatedDate}
                  onChange={(item) => {
                    setUpdatedDate(item.target.value);
                  }}
                />
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div class="form-sub-div">
              <label class="form-label">
                {`num Of Times Used In Exam >=`}{" "}
              </label>
              <div class="form-elements" style={{ fontSize: "15px" }}>
                <Input
                  type="number"
                  value={numOfTimesUsedInExam}
                  onChange={(item) => {
                    setNumOfTimesUsedInExam(item.target.value);
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
           <Button
              variant="outlined"
              style={{
                marginRight: "5px",
                marginBottom: "5px",
              }}
              onClick={() => {
                onReset()
                onResetConfig() 
                }
              }
            >
              Reset Filter
            </Button>
            <Button
              variant="outlined"
              style={{
                marginBottom: "5px",
              }}
              disabled={subjectIds.length === 0}
              onClick={() => {
                return props?.addConfig({
                  approvedBy,
                  courseIds,
                  subjectIds,
                  tagIds,
                  topicIds,
                  createdBy,
                  questionComplexity,
                  numOfTimesUsedInExam,
                  issueReported,
                  includeQuestionsFromQB,
                  createdDate,
                  updatedDate,
                  totalQuestion
                });
              }}
            >
              Add Filter
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
